__turbopack_context__.v({
  "richText": "SectionContainer-module__qqQ05G__richText",
  "sectionContent": "SectionContainer-module__qqQ05G__sectionContent",
});
